var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import Label from '../Label/Label';
import Error from '../Error/Error';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
const TextAreaStyleContainer = styled.div `
  position: relative;
  box-sizing: border-box;
  margin-bottom: ${props => props.theme.spacings.halfSpacing};
  ${props => props.noMargin &&
    css `
      margin-bottom: 0px;
    `} width: 100%;
`;
const TextAreaStyle = styled.textarea `
  position: relative;
  box-sizing: border-box;
  font-family: ${props => props.theme.fonts.fontFamily};
  font-size: ${props => props.theme.utils.getSize(props.size)};
  width: inherit;
  height: auto;
  color: ${props => props.theme.utils.getColor(props.color)};
  background-color: white;
  resize: ${props => props.resize};
  padding: ${props => props.theme.paddingsMargins.themePadding};
  border: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
  border-radius: ${props => props.theme.borders.inputsBorderRadius};
  &:focus {
    outline: none;
    border: 1px solid ${props => props.theme.utils.getColor(props.color)};
  }
`;
const TextArea = forwardRef((_a, ref) => {
    var { onChange = () => { }, resize = 'both', label, labelSize, size = 'article', noMargin = false, noBorder = false, errors = {}, register, placeholder = '', cols, rows, disabled, name, value, color = 'main', labelColor, isLoading, skeleton, skeletonLabel, textAreaStyle, excludeMeFromLoadingContext = false, refArea } = _a, props = __rest(_a, ["onChange", "resize", "label", "labelSize", "size", "noMargin", "noBorder", "errors", "register", "placeholder", "cols", "rows", "disabled", "name", "value", "color", "labelColor", "isLoading", "skeleton", "skeletonLabel", "textAreaStyle", "excludeMeFromLoadingContext", "refArea"]);
    const { loadingContext } = useCronoSkeleton();
    return (_jsxs(TextAreaStyleContainer, Object.assign({ noMargin: noMargin }, props, { children: [!!label &&
                _jsx(Label, { label: label, labelSize: labelSize, color: labelColor || color, isLoading: (loadingContext && excludeMeFromLoadingContext === false) || isLoading, skeleton: skeletonLabel }), (loadingContext && excludeMeFromLoadingContext === false) || isLoading
                ? _jsx(Skeleton, Object.assign({ height: "4rem", width: "inherit", margin: "v" }, skeleton))
                : _jsx(TextAreaStyle, { style: textAreaStyle, ref: refArea, size: size, onChange: e => onChange(e), noBorder: noBorder, placeholder: placeholder, resize: resize, cols: cols, rows: rows, disabled: disabled, name: name, color: color, value: value }), !!errors[name] &&
                _jsx(Error, { children: errors[name].message })] })));
});
export default TextArea;
